<template>
    <v-container>
        <div v-if="!reports_checkstatus.reportEvents || !enddate || !startdate">
            <h3>Loading events...</h3>
        </div>
        <div v-else id="eventcontainer">
            <h1 class="mb-1" v-html=" mergedConfig.eventtitle || 'Event History' "></h1>
            <div v-if="!eventCount && !mergedConfig.showemptyeventdays" id='eventsbetween'>
                No Events {{betweenDates}}.
            </div>
            <div v-else>
                <div id='eventsbetween'>
                    Showing Events {{betweenDates}}.
                </div>
                <div v-for="(record, day) in fillDates" :key="day">
                    <ReportEventsDay :record="record" :day="day"  />
                </div>
            </div>
            <v-row  v-if="showmore">
                <v-btn class="ma-2" outlined @click="getNextPage()">Load More</v-btn>
                <div v-if="showmoremessage" class="showmoremessage">{{showmoremessage}}</div>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
// import { formatCapitalizeFirst, filterId } from "../lib/filter";
import {
    format as date_format,
    // distanceInWords as date_formatDistance,
    parse as date_parse,
    eachDay as date_eachDay,
    subDays as date_subDays,
    subWeeks as date_subWeeks,
    subMonths as date_subMonths
} from "date-fns";
import _size from "lodash/size";

import ReportEventsDay from "./Reports_Checkstatus_Events_Day";

const eventslimitspans = {

    "all": (d) => date_format(date_parse(d), "YYYY-MM-DD" ),
    "days": (i) => date_format(date_subDays(new Date, 1 * (i || 1)), "YYYY-MM-DD"),
    "weeks": (i) => date_format(date_subWeeks(new Date, 1 * (i || 1)),"YYYY-MM-DD"),
    "months": (i) => date_format(date_subMonths(new Date, 1 * (i || 1)),"YYYY-MM-DD"),
    "One day": () => date_format(date_subDays(new Date, 1), "YYYY-MM-DD"),
    "One week": () => date_format(date_subWeeks(new Date, 1),"YYYY-MM-DD"),
    "Two weeks": () => date_format(date_subWeeks(new Date, 2),"YYYY-MM-DD"),
    "One month": () => date_format(date_subMonths(new Date, 1),"YYYY-MM-DD"),
    "Three months": () => date_format(date_subMonths(new Date, 3) ,"YYYY-MM-DD")
};


export default {
    name: "ReportEvents",
    props: {
        runpolling: {
            type: Boolean,
            default: false
        },
        reportid: {
            type: String
        }
    },
    components: { ReportEventsDay },
    data () {
        return {
            page: 0,
            startdate: false,
            enddate: false,
            checkcache: {},
            showmoremessage: false,
            // showmore: true,
            showdiag: false
        }
    },
    computed: {
        ...mapState(["currentUser", "reports_checkstatus", "now"]),
        ...mapGetters("reports_checkstatus", ["mergedConfig"]),
        eventCount: function () {
            return _size(this.reports_checkstatus.reportEvents)
        },
        betweenDates: function () {
            if(this.startdate && this.enddate ){
                let offset = this.reports_checkstatus.eventParams.offset || 0;
                let start = date_format(date_parse(this.startdate - offset), 'YYYY-MM-DD');
                let end = date_format(date_parse(this.enddate - offset), 'YYYY-MM-DD');
                return " Between " + start + " and " + end;
            } else {
                return ""
            }
        },
        fillDates: function () {
            // let showemptyeventdays = (this.mergedConfig.check && this.reports_checkstatus.reportConfig.check.showemptyeventdays) || this.reports_checkstatus.reportConfig.showemptyeventdays || false;
            // let interval = (this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.eventsinterval) || this.reports_checkstatus.reportConfig.eventsinterval || "months";

            // let startdate;
            // let enddate;
            var days;

            // console.log('fillDates', showemptyeventdays, interval, this.startdate, this.enddate, this.page);
            // console.log(date_formatDistance(date_parse(this.startdate), date_parse(this.enddate) ) );
            // console.log(date_formatDistance)

            if(this.mergedConfig.showemptyeventdays){
                days = {};
                // days = {...this.reports_checkstatus.reportEvents};
                // let now = new Date();
                // if(!this.startdate){
                //     if(interval === "days"){
                //         startdate = date_subDays(now, this.page + 1);
                //     }else if (interval === "weeks"){
                //         startdate =  date_subWeeks(now, this.page + 1);
                //     } else {
                //         startdate =  date_subMonths(now, this.page + 1);
                //     }
                // }
                // if (!enddate) {
                //     if (!this.page ) {
                //         enddate = now;
                //     } else if(interval === "days"){
                //         enddate = date_subDays(now, this.page );
                //     }else if (interval === "weeks"){
                //         enddate =  date_subWeeks(now, this.page );
                //     } else {
                //         enddate =  date_subMonths(now, this.page );
                //     }
                // }
                var datelist = date_eachDay(this.startdate, this.enddate);
                let d = datelist.length;
                // console.log("Showing empty event days.", datelist.length)
                while( d-- ){
                    let fdate = date_format(datelist[d], 'YYYY-MM-DD');
                    // console.log(fdate, days[fdate]);
                    days[fdate] = this.reports_checkstatus.reportEvents[fdate] || [];
                }
            } else {
                // console.log('not filling in empty days because showemptyeventdays is set to', this.mergedConfig.showemptyeventdays, this.mergedConfig);
                days = this.reports_checkstatus.reportEvents || {};
            }
            // console.log('fillDates days', datelist, days);
            return days;
        },
        showmore: function() {
            let notbefore = (this.mergedConfig.eventsnotbefore && eventslimitspans[this.mergedConfig.eventsnotbefore]) ? eventslimitspans[this.mergedConfig.eventsnotbefore]() : false;
            let startdate = date_format(date_parse(this.startdate),"YYYY-MM-DD");
            let created = date_format(date_parse(this.reports_checkstatus.reportCheck.created),"YYYY-MM-DD");
            // console.log('showmore\n', this.mergedConfig.eventsnotbefore , '\nnotbefore', notbefore, '\nstartdate', startdate, '\ncreated', created, '\n SO (notbefore < startdate && created < startdate ):', (notbefore < startdate && created < startdate ))
            return ((!notbefore || notbefore < startdate) && (!created || created < startdate) ); // current start date is after notbefore and before check's created date
        }
    },
    methods: {
        startPolling: function (options){
            // console.log("Event polling", this.runpolling);
            clearTimeout(this.$options.polling);
            options = options || {};
            this.getEvents(options)
                .then( () => {
                    // console.log('events set?', this.reports_checkstatus.reportEvents);
                    this.$options.polling = setTimeout(
                        () => { this.startPolling({poll: true}) },
                        60000
                    )
                })
        },
        stopPolling: function (){
            if (this.$options && this.$options.polling) {
                clearTimeout(this.$options.polling);
            }
        },
        getEvents: function (options){
            // console.log('getEvents', options);
            var ypos = window.pageYOffset;
            options = options || {};
            let params = {
                reportid: this.reportid
            };

            if(options.poll){   // typically all regular polling
                // will default to start = now - interval
                //                   end = now
                // params.start = Date.now() - 3600000;
                // params.end = Date.now();
            } else { // first run on component load, and the "load more" clicks
                params.eventpage = this.page;
            }

            return this.$store
                .dispatch("reports_checkstatus/getEvents", params)
                .then( () => {
                    var dates = Object.keys(this.reports_checkstatus.reportEvents);
                    var dlength = dates.length;

                    if(!this.startdate || this.reports_checkstatus.eventParams.start < this.startdate) this.startdate = this.reports_checkstatus.eventParams.start;
                    if(!this.enddate || this.reports_checkstatus.eventParams.end > this.enddate) this.enddate = this.reports_checkstatus.eventParams.end;

                    let created = this.reports_checkstatus.reportCheck.created - 0;

                    if(this.showmoremessage){
                        if(dlength){
                            this.showmoremessage = "Showing Events " + this.betweenDates;
                        } else {
                            this.showmoremessage = "No additional events in the requested timeframe.";
                        }
                        setTimeout(() =>{ this.showmoremessage = false;}, 3500)
                    }

                    while( dlength-- ){
                        let d = dates[dlength];
                        for(let i in this.reports_checkstatus.reportEvents[d]){
                            if(this.reports_checkstatus.reportEvents[d][i].type === "start"){
                                break;
                            } else {
                                // console.log(this.reports_checkstatus.reportEvents[d][i].type, " isn't a start.")
                            }
                        }
                    }
                    this.$nextTick(() => {
                        window.scrollTo(0, ypos)
                    });
                    // console.log('events', this.reports_checkstatus.reportEvents);
                })
                .catch( (e) => {
                    console.log('error getting events', e)
                    return e.message;
                })
        },
        getNextPage: function() {
            this.page++;
            this.startPolling({page: true});
            let message = this.mergedConfig.eventsinterval || "months";
            const messages = {
                days: "another day of",
                weeks: "another week of",
                months: "another month of"
            }
            message = "Fetching " + (messages[message] || "more") + " events";
            if(this.reports_checkstatus &&this.reports_checkstatus.eventParams && this.reports_checkstatus.eventParams.more) message += " (up to 50 records)";
            this.showmoremessage = message;
        }
    },
    created () {
        // this.startPolling();
    },
    watch: {
        runpolling: {
            immediate: true,
            handler(newVal, oldVal) {
                // console.log('runpolling handler in events', newVal, oldVal);
                if(newVal){
                    this.startPolling();
                } else {
                    this.stopPolling();
                }
            }
        }
    },
    beforeDestroy: function () {
        // console.log('events beforeDestroy');
        this.stopPolling()
    },
    deactivated: function () {
        // console.log('events deactivated');
        this.stopPolling();
    }
}
</script>

<style scoped>
.eventdesc {
    font-weight: bold;
}
#eventsbetween {
    margin-bottom: 16px;
}
.showmoremessage {
    margin-left: 12px;
    padding-top: 12px;
}
.diagnostics label {
    width: 200px;
    margin-right: 12px;
}
.diagnostics textarea { 
    font-family: monospace, monospace;
}
</style>